import React,{useEffect,} from 'react';
import { Helmet } from "react-helmet";  

function Plans() {
    document.title = 'Plan';
    window.location.replace ('https://www.travsie.com/plans/index.php');
}

export default Plans;